import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";
import { SvgLoaderOptions } from "./SvgLoader.js";

export interface JsonLoaderOptions extends AjaxLoaderOptions {

}

export class JsonLoader<Data> extends AbstractAjaxLoader<Data, JsonLoaderOptions>{
    protected defaultOptions(): SvgLoaderOptions {
        return {
            decoder: "json",
            encoder: "json"
        }
    }
}

registerLoader("json", JsonLoader);